import { render, staticRenderFns } from "./OrderRefundDialog.vue?vue&type=template&id=5958b080&scoped=true"
import script from "./OrderRefundDialog.vue?vue&type=script&lang=js"
export * from "./OrderRefundDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderRefundDialog.vue?vue&type=style&index=0&id=5958b080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5958b080",
  null
  
)

export default component.exports